import { render } from "./InputSearchDrug.vue?vue&type=template&id=2f120def&scoped=true"
import script from "./InputSearchDrug.vue?vue&type=script&lang=js"
export * from "./InputSearchDrug.vue?vue&type=script&lang=js"

import "./InputSearchDrug.vue?vue&type=style&index=0&id=2f120def&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f120def"]])

export default __exports__